export default __webpack_public_path__ + "static/media/fsc.cf95a5f0.png";